const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5172/api";
// 📦 Check Pincode Service

export const checkPincodeService = async (pincode,weight) => {
  try {
    const response = await fetch(`${API_URL}/pincode/check-pincode`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ pincode, weight }),
    });

    const data = await response.json();

    return data;
  } catch (error) {
    console.error("Pincode API Error:", error);
    return {
      success: false,
      message: "Something went wrong",
    };
  }
};
